export { UserAdd2 as default } from './UserAdd2';
